import React from "react";
import cssClasses from "./Drive.module.css";
import SearchBar from "../../Subcomponents/Search";
import { debounce, filter } from "lodash";
import { useRef } from "react";
import DropDown from "../../Subcomponents/DropDown";
import { useState } from "react";
import NewFolderModal from "../Project/NewFolderModal/NewFolderModel";
import CustomDateModal from "../Project/CustomDateModal/CustomDateModal";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import FileManager from "../FileManager";
import SelectManagerModal from "../FileManager/SelectManagerModal";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import { errorTost, successTost } from "../../Services/Toast";
import CloseIcon from "@mui/icons-material/Close";
import { dismissLoader, presentLoader } from "../../Services/loader";
import {
  UploadFile,
  createFolderInDrive,
  deleteFileFromStorage,
  downloadFile,
  listAllFileOfBucket,
  removeFileFromTable,
  retriveBucketInDrive,
} from "../../Services/Drive";
import {
  AddProjectCollateralWithCp,
  AddProjectCollaterals,
  getAllProjectsCollateral,
  getProjectCollateralWithId,
} from "../../Services/Project";
import { useEffect } from "react";
import JsFileDownloader from "js-file-downloader";
import EmptyState from "../../Assets/Images/Common/noProjectFound.svg";
import axios from "axios";

const driveFolderOptions = [
  { id: 0, value: "Share", label: "Share" },
  // { id: 1, value: "Download", label: "Download" },
];

const Drive = ({ ProjectData }) => {
  const [data, setData] = useState([]);
  const [projectCollateralData, setProjectCollateralData] = useState([]);
  const searchValue = useRef("");
  const inputFile = useRef("");
  const [newCreate, setNewCreate] = useState("");
  const [typeBy, setTypeBy] = useState("");
  const [dateBy, setDateBy] = useState("");
  const [isNewFolderCreateModal, setIsNewFolderCreateModal] = useState(false);
  const [showCustomDateModal, setShowCustomDateModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteFile, setSelectedDeleteFile] = useState("");
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [rangeDate, setRangeDate] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [mainProjectCollateralData, setMainProjectCollateralData] = useState(
    []
  );
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [flowSet, setFlowSet] = useState([ProjectData[0]?.projectName]);
  const [isBreadcrumbChange, setIsBreadcrumbChange] = useState(false);
  const [breadcrumbData, setBreadcrumbData] = useState(null);
  const [flowData, setFlowData] = useState([
    <Link
      underline="hover"
      key="3"
      fontFamily={"inter-medium"}
      fontWeight={500}
      fontSize={"1.6rem"}
      color="rgba(29, 41, 57, 1)"
      onClick={() => {
        handleBreadcrumb(null);
      }}
    >
      {ProjectData[0]?.projectName}
    </Link>,
  ]);
  const [dateModifiedOptions, setDateModifiedOptions] = useState([
    { id: 0, label: "Today", value: "Today" },
    { id: 1, label: "Last 7 Days", value: "Last 7 Days" },
    { id: 2, label: "Last 30 Days", value: "Last 30 Days" },
    { id: 3, label: "Custom Date", value: "Custom Date" },
  ]);
  const [typeOptions, setTypeOptions] = useState([
    { id: 0, label: "Folder", value: "Folder" },
    { id: 1, label: "Image", value: "image" },
    { id: 2, label: "Video", value: "video" },
    { id: 3, label: "Word File", value: "Word File" },
    { id: 4, label: "Presentation", value: "Presentation" },
    { id: 5, label: "SpreadSheet", value: "SpreadSheet" },
    { id: 6, label: "Other", value: "Other" },
  ]);

  useEffect(() => {
    presentLoader();
    //fetchAllDataFromBucket();
    fetchAllDataFromStorage();
  }, []);

  useEffect(() => {
    getProjectCollateralWithId(
      ProjectData[0]?.projectId,
      ProjectData[0]?.projectName
    )
      .then((project) => {
        if (project?.length === 0) {
          presentLoader();
          createFolderInDrive(`${ProjectData[0].projectName}`)
            .then((resp) => {
              if (resp) {
                let obj = {
                  projectId: ProjectData[0]?.projectId,
                  createdBy: ProjectData[0]?.userId,
                  fileUrl: resp?.data?.Key,
                  fileType: "folder",
                  fileName: ProjectData[0].projectName,
                  parentId: null,
                };
                AddProjectCollaterals(obj)
                  .then((resp) => {
                    setMainProjectCollateralData(resp?.data);
                    dismissLoader();
                  })
                  .catch((err) => {
                    dismissLoader();
                    errorTost(err?.message);
                  });
              }
            })
            .catch((err) => {
              errorTost(err?.message);
              dismissLoader();
            });
        } else {
          setMainProjectCollateralData(project);
        }
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
  }, [ProjectData]);
  useEffect(() => {
    presentLoader();
    fetchAllDataFromBucket();
  }, [typeBy, dateBy, rangeDate]);

  useEffect(() => {
    fetchAllDataFromBucket();
  }, [selectedFolderId]);

  useEffect(() => {
    if (
      flowSet?.filter((val) => val.fileName === breadcrumbData?.fileName)
        ?.length > 0 &&
      breadcrumbData !== null
    ) {
      setSelectedFolder(breadcrumbData);
      setSelectedFolderId(breadcrumbData?.projectCollateralId);
      const index = flowSet?.findIndex(
        (val) => val.fileName === breadcrumbData?.fileName
      );
      const payload = flowSet.slice(0, index + 1);
      setFlowSet(payload);
      const payload1 = [];
      payload.forEach((val) => {
        if (typeof val === "string") {
          payload1.push(
            <Link
              underline="hover"
              key="3"
              fontFamily={"inter-medium"}
              fontWeight={500}
              fontSize={"1.6rem"}
              color="rgba(29, 41, 57, 1)"
              onClick={() => {
                handleBreadcrumb(null);
              }}
            >
              {ProjectData[0]?.projectName}
            </Link>
          );
        } else {
          payload1.push(
            <Link
              underline="hover"
              key="3"
              fontFamily={"inter-medium"}
              fontWeight={500}
              fontSize={"1.6rem"}
              color="rgba(29, 41, 57, 1)"
              onClick={() => {
                handleBreadcrumb(val);
              }}
            >
              {val.fileName}
            </Link>
          );
        }
      });
      setFlowData(payload1);
    } else if (breadcrumbData === null) {
      setSelectedFolder(null);
      setSelectedFolderId(null);
      setFlowSet([ProjectData[0]?.projectName]);
      setFlowData([
        <Link
          underline="hover"
          key="3"
          fontFamily={"inter-medium"}
          fontWeight={500}
          fontSize={"1.6rem"}
          color="rgba(29, 41, 57, 1)"
          onClick={() => {
            handleBreadcrumb(null);
          }}
        >
          {ProjectData[0]?.projectName}
        </Link>,
      ]);
    }
  }, [isBreadcrumbChange]);

  const fetchAllDataFromStorage = async () => {
    listAllFileOfBucket(`${ProjectData[0]?.projectName}`, searchValue?.current)
      .then((resp) => {
        dismissLoader();
        setProjectCollateralData(resp?.data);
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err?.message);
      });
  };

  const handleBreadcrumb = (value = null) => {
    // setTypeBy("");
    // setDateBy("");
    // setRangeDate([
    //   { label: "StartDate", value: "" },
    //   { label: "EndDate", value: "" },
    // ]);
    setSelectedFolderId(value === null ? null : value?.projectCollateralId);
    setBreadcrumbData(value);
    setIsBreadcrumbChange(!isBreadcrumbChange);
  };

  const fetchAllDataFromBucket = () => {
    getAllProjectsCollateral(
      `${ProjectData[0]?.projectId}`,
      searchValue?.current,
      typeBy,
      rangeDate,
      selectedFolderId
    )
      .then((resp) => {
        dismissLoader();
        if (resp) {
          const payload = resp?.data?.map((val) => {
            return { ...val, name: val?.fileName };
          });
          setData(payload);
        }
      })
      .catch((err) => {
        dismissLoader();
        setSelectedFolderId(null);
        errorTost(err?.message);
      });
  };
  const createFolderHandler = async (e) => {
    setNewCreate("");
    presentLoader();
    createFolderInDrive(
      `${
        selectedFolder
          ? selectedFolder?.fileUrl
              ?.split("/.")[0]
              ?.split("projectcollaterals/")[1]
          : ProjectData[0]?.projectName
      }/${e}`
    )
      .then((resp) => {
        if (resp) {
          let obj = {
            projectId: ProjectData[0]?.projectId,
            createdBy: ProjectData[0]?.userId,
            fileUrl: resp?.data?.Key,
            fileType: "folder",
            fileName: e,
            parentId: selectedFolder
              ? selectedFolder?.projectCollateralId
              : mainProjectCollateralData[0]?.projectCollateralId,
          };
          AddProjectCollaterals(obj)
            .then((resp) => {
              fetchAllDataFromStorage();
              fetchAllDataFromBucket();
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err?.message);
            });
        }
      })
      .catch((err) => {
        errorTost(err?.message);
        dismissLoader();
      });
  };

  const debouncedFetchSearchData = debounce((e) => {
    searchValue.current = e.target.value;
    presentLoader();
    fetchAllDataFromBucket();
  }, 500);

  const handleAddFile = (e) => {
    setNewCreate(e);
    if (e === "New Folder") {
      setNewCreate("");
      setIsNewFolderCreateModal(true);
    } else {
      inputFile.current.click();
    }
  };

  const handleDateModified = (e) => {
    setDateBy(e);
    if (e === "Today") {
      const startDate = new Date().setHours(0, 0, 0);
      const endDate = new Date().setHours(23, 59, 0);
      setRangeDate((pre) => {
        pre[0].value = startDate;
        pre[1].value = endDate;
        return { ...pre };
      });
    } else if (e === "Last 7 Days") {
      const startDate = new Date().getTime();
      const d = new Date();
      const endDate = new Date(d.setDate(d.getDate() - 7)).setHours(0, 0, 0);
      setRangeDate((pre) => {
        pre[0].value = endDate;
        pre[1].value = startDate;
        return { ...pre };
      });
    } else if (e === "Last 30 Days") {
      const startDate = new Date().getTime();
      const d = new Date();
      const endDate = new Date(d.setDate(d.getDate() - 30)).setHours(0, 0, 0);
      setRangeDate((pre) => {
        pre[0].value = endDate;
        pre[1].value = startDate;
        return { ...pre };
      });
    } else if (e === "Custom Date") {
      setShowCustomDateModal(true);
    }
  };

  const handleSetToggle = (value) => {
    setData([]);
    setSelectedFolder(value);
    setSelectedFolderId(value?.projectCollateralId);
    setFlowSet((prev) => {
      return [...prev, value];
    });
    setFlowData((pre) => {
      return [
        ...pre,
        <Link
          underline="hover"
          key="3"
          fontFamily={"inter-medium"}
          fontWeight={500}
          fontSize={"1.6rem"}
          color="rgba(29, 41, 57, 1)"
          onClick={() => {
            handleBreadcrumb(value);
          }}
        >
          {value.fileName}
        </Link>,
      ];
    });
  };
  const handleDeleteFile = async (val) => {
    const selectedFileToDelete = data.find(
      (file) => file.name?.split(".")[0] === val
    );
    presentLoader();
    deleteFileFromStorage(
      `${
        selectedFileToDelete?.fileUrl
          ?.split("/.emptyFolderPlaceholder")[0]
          ?.split("projectcollaterals/")[1]
      }`
    )
      .then((resp) => {
        if (resp) {
          removeFileFromTable(val)
            .then(() => {
              dismissLoader();
              fetchAllDataFromStorage();
              fetchAllDataFromBucket();
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        }
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  const handleDeleteFolder = async (val) => {
    const selectedFileToDelete = data.find(
      (file) => file.name?.split(".")[0] === val
    );
    presentLoader();
    axios
      .post(
        process.env.REACT_APP_PAYMENT_LINK_URL +
          "payments/deleteFolderFromStorage",
        {
          bucketName: "projectcollaterals",
          folder: selectedFileToDelete?.fileUrl
            ?.split("/.emptyFolderPlaceholder")[0]
            ?.split("projectcollaterals/")[1],
        }
      )
      .then((resp) => {
        if (resp) {
          removeFileFromTable(val)
            .then(() => {
              dismissLoader();
              fetchAllDataFromStorage();
              fetchAllDataFromBucket();
            })
            .catch((err) => {
              dismissLoader();
              errorTost(err.message);
            });
        }
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  const handleDeleteFromList = (e) => {
    if (e === "type") {
      presentLoader();
      setTypeBy("");
    } else {
      presentLoader();
      setDateBy("");
      setRangeDate([
        { label: "StartDate", value: "" },
        { label: "EndDate", value: "" },
      ]);
    }
  };

  const handleFileSelect = (e) => {
    setNewCreate("");
    presentLoader();
    toBase64(e?.target.files[0])
      .then((res) => {
        UploadFile(
          res,
          selectedFolder
            ? selectedFolder?.fileUrl
                ?.split("/.")[0]
                ?.split("projectcollaterals/")[1]
            : ProjectData[0]?.projectName
        )
          .then((value) => {
            if (value) {
              const type = typCheck(e?.target?.files[0]);
              let obj = {
                projectId: ProjectData[0]?.projectId,
                createdBy: ProjectData[0]?.userId,
                fileUrl: value?.data?.Key,
                fileType: type,
                fileName: e?.target?.files[0]?.name.split(".")[0],
                parentId: selectedFolder
                  ? selectedFolder?.projectCollateralId
                  : mainProjectCollateralData[0]?.projectCollateralId,
              };
              AddProjectCollaterals(obj)
                .then((resp) => {
                  inputFile.current.value = "";
                  fetchAllDataFromStorage();
                  fetchAllDataFromBucket();
                })
                .catch((err) => {
                  inputFile.current.value = "";
                  dismissLoader();
                  errorTost(err?.message);
                });
            }
          })
          .catch((err) => {
            dismissLoader();
            errorTost(err.message);
          });
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (file.type.includes("image/")) {
        const image = new Image();
        image.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = image.naturalWidth;
          canvas.height = image.naturalHeight;
          canvas.getContext("2d").drawImage(image, 0, 0);
          canvas.toBlob((blob) => {
            let myFile = new File([blob], `${file.name.split(".")[0]}.webp`, {
              type: blob.type,
            });
            resolve(myFile);
          }, "image/webp");
        };
        image.onerror = (err) => {};
        image.crossOrigin = "anonymous";
        image.src = URL.createObjectURL(file);
      } else {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          let myFile = new File([e.target.result], file.name, {
            type: file.type,
          });
          // let myFile = e.target.result;
          resolve(myFile);
        };
        fileReader.onerror = (err) => {};
        fileReader.readAsArrayBuffer(file);
      }
    });
  };

  const handleDownloadFile = (value) => {
    presentLoader();
    downloadFile(value?.fileUrl?.split("projectcollaterals/")[1])
      .then((val) => {
        dismissLoader();
        // const a = document.createElement("a");
        // a.href = URL.createObjectURL(
        //   new Blob([JSON.stringify(val?.data, null, 2)], {
        //     type: val?.data?.type,
        //   })
        // );
        // a.setAttribute("download", value?.fileName);
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(val?.data);
        link.download = `${value?.fileName}`;
        link.click();
      })
      .catch((err) => {
        errorTost(err.message);
        dismissLoader();
      });
    // new JsFileDownloader({
    //   url: process.env.REACT_APP_SUPABASE_BUCKET_PREFIX + value?.fileName,
    // })
    //   .then(() => {
    //     dismissLoader();
    //   })
    //   .catch((err) => {
    //     dismissLoader();
    //     errorTost(err.message);
    //   });
  };

  const handleShareCollateral = (
    cpNames,
    salesName,
    selectedFile,
    selectDates
  ) => {
    setShowShareModal(false);
    presentLoader();
    const obj = {
      cpidarr: cpNames?.length > 0 ? [...cpNames] : [],
      salesidarr: salesName?.length > 0 ? [...salesName] : [],
      projectCollateralId: mainProjectCollateralData[0]?.projectCollateralId,
      startDateTime: Date.parse(new Date(selectDates[0]?.value)),
      endDateTime: Date.parse(new Date(selectDates[1]?.value)),
    };
    axios
      .post(process.env.REACT_APP_PAYMENT_LINK_URL + "scheduler/ShareFolder", {
        ...obj,
      })
      .then(() => {
        successTost("Collateral shared sucessfully.");
        dismissLoader();
      })
      .catch((err) => {
        dismissLoader();
        errorTost(err.message);
      });
  };

  return (
    <div className={cssClasses.mainContainer}>
      <div className={cssClasses.filterContainer}>
        <SearchBar
          width={"500px"}
          placeholder={"Search in Drive"}
          search={debouncedFetchSearchData}
          id={"drive"}
        />
        <div>
          <DropDown
            onChangeSelect={(e) => {
              handleAddFile(e);
            }}
            selectedValue={newCreate}
            placeHolder="New"
            style={{
              selectedColor: "#175CD3",
              background: "#fff",
              minWidth: "90px",
            }}
            list={["New Folder", "File Upload"]}
            addIconDisplay
          />
          <input
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={(e) => handleFileSelect(e)}
          />
        </div>

        <DropDown
          placeHolder="Filter By"
          onChangeSelect={(e) => {
            setTypeBy(e);
          }}
          selectedValue={typeBy}
          style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
          list={typeOptions}
          //disable={data?.length === 0}
        />

        <DropDown
          placeHolder="Last Modified"
          onChangeSelect={(e) => {
            handleDateModified(e);
          }}
          selectedValue={dateBy}
          style={{
            selectedColor: "#175CD3",
            background: "#E8F0FE",
            minWidth: "135px",
          }}
          list={dateModifiedOptions}
          //disable={data?.length === 0}
        />
      </div>
      <div className={cssClasses.breadcrumbContainer}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
        >
          {flowData}
        </Breadcrumbs>
        {flowSet?.length === 1 && (
          <ThreeDotsMenu
            list={driveFolderOptions}
            selectedValue={(e) => {
              if (e?.value === "Share") {
                setShowShareModal(true);
              } else if (e.label === "Delete") {
                setShowDeleteModal(true);
                setSelectedDeleteFile(ProjectData[0]?.projectName);
              } else if (e.label === "Download") {
                handleDownloadFile(null, ProjectData[0]?.projectName);
              }
            }}
          />
        )}
      </div>
      <div style={{ display: "flex", gap: "1rem" }}>
        {dateBy !== "" && (
          <div className={cssClasses.selectedListContainer}>
            <div className={cssClasses.selectedList}>
              {dateBy}
              <CloseIcon
                style={{ fontSize: "2rem", cursor: "pointer" }}
                onClick={() => handleDeleteFromList("date")}
              />
            </div>
          </div>
        )}
        {typeBy !== "" && (
          <div className={cssClasses.selectedListContainer}>
            <div className={cssClasses.selectedList}>
              {typeBy}
              <CloseIcon
                style={{ fontSize: "2rem", cursor: "pointer" }}
                onClick={() => handleDeleteFromList("type")}
              />
            </div>
          </div>
        )}
      </div>
      {data?.filter((val) => val?.fileType === "folder")?.length > 0 && (
        <div>
          <div className={cssClasses.folderFileWrapper}>
            <span style={{ fontSize: "2rem " }}>Folders</span>
            <FileManager
              value={data?.filter((val) => val?.fileType === "folder")}
              handleDeleteFile={(e) => handleDeleteFolder(e)}
              handleSetToggle={(e) => handleSetToggle(e)}
              handleDownloadFile={(e) => handleDownloadFile(e)}
            />
          </div>
        </div>
      )}
      {data?.filter((val) => val?.fileType !== "folder")?.length > 0 && (
        <div>
          <div className={cssClasses.folderFileWrapper}>
            <span style={{ fontSize: "2rem " }}>Files</span>
            <FileManager
              value={data?.filter((v) => v.fileType !== "folder")}
              handleDeleteFile={(e) => handleDeleteFile(e)}
              handleSetToggle={(e) => handleSetToggle(e)}
              handleDownloadFile={(e) => handleDownloadFile(e)}
            />
          </div>
        </div>
      )}

      {data?.length === 0 && (
        <div style={{ height: "100%" }}>
          <p
            style={{
              position: "relative",
              top: "100%",
              transform: "translateY(-50%)",
              textAlign: "center",
              fontSize: "3rem",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img src={EmptyState} alt="No Data" />
              <span>No Data Available</span>
            </div>
          </p>
        </div>
      )}

      {showShareModal && (
        <SelectManagerModal
          open={showShareModal}
          handleClose={() => {
            setShowShareModal(false);
          }}
          selectedFile={mainProjectCollateralData}
          mainProjectShare
          submitHandler={(cp, sm, selectedFile, selectDates) => {
            handleShareCollateral(cp, sm, selectedFile, selectDates);
          }}
        />
      )}
      {isNewFolderCreateModal && (
        <NewFolderModal
          open={isNewFolderCreateModal}
          handleClose={() => {
            setIsNewFolderCreateModal(false);
          }}
          label={"New Folder"}
          submitHandler={(e) => {
            createFolderHandler(e);
            setIsNewFolderCreateModal(false);
          }}
        />
      )}
      {showRenameModal && (
        <NewFolderModal
          open={showRenameModal}
          handleClose={() => {
            setShowRenameModal(false);
          }}
          label={"Rename"}
          submitHandler={(e) => {
            setShowRenameModal(false);
          }}
          nameValue={ProjectData[0]?.projectName}
        />
      )}
      {showCustomDateModal && (
        <CustomDateModal
          open={showCustomDateModal}
          handleClose={() => {
            setShowCustomDateModal(false);
          }}
          submitHandler={(e) => {
            setRangeDate((pre) => {
              pre[0].value = Date.parse(new Date(e[0].value));
              pre[1].value = Date.parse(new Date(e[1].value));
              return { ...pre };
            });
            setShowCustomDateModal(false);
            fetchAllDataFromBucket();
          }}
        />
      )}
      {showDeleteModal && (
        <ConfirmationAlert
          confirm={(e) => {
            if (e === "confirmed") {
              //changePriceSubmitHandler();
            }
          }}
          buttonTitle={"Cancel"}
          returnRespButton={"Delete"}
          close={() => {
            setShowDeleteModal(false);
          }}
          title={"Delete ?"}
          subTitle={`${selectedDeleteFile} will be deleted forever`}
          open={showDeleteModal}
        />
      )}
    </div>
  );
};

function typCheck(val) {
  let allowedExtension = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/bmp",
  ];
  let videoExtensions = [
    "video/m4v",
    "video/avi",
    "video/mpg",
    "video/mp4",
    "video/webm",
  ];
  let spreadExtension = [
    "application/excel",
    "application/vnd.ms-excel",
    "application/x-excel",
    "application/x-msexcel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.oasis.opendocument.spreadsheet",
  ];
  let wordExtension = [
    "application/doc",
    "application/ms-doc",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  let pptExtensions = [
    "application/mspowerpoint",
    "application/powerpoint",
    "application/vnd.ms-powerpoint",
    "application/x-mspowerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/vnd.oasis.opendocument.presentation",
  ];
  let pdfExtension = ["application/pdf"];

  if (allowedExtension.indexOf(val.type) > -1) {
    return "image";
  } else if (videoExtensions.indexOf(val.type) > -1) {
    return "video";
  } else if (spreadExtension.indexOf(val.type) > -1) {
    return "SpreadSheet";
  } else if (wordExtension.indexOf(val.type) > -1) {
    return "Word File";
  } else if (pptExtensions.indexOf(val.type) > -1) {
    return "Presentation";
  } else {
    return "Other";
  }
}

export default Drive;
